

















































import { Component, Vue } from "vue-property-decorator";
import { PublicHolidayEditModel } from "@/services/api/nswag/stapiclient_generated";
import { stPublicHolidayApi } from "@/services/st-api";
import StRatePicker from "@/components/basic/StRatePicker.vue";
import SlideIn from "@/components/basic/SlideIn.vue";
import StInput2 from "@/components/basic/StInput2.vue";
import StToggle from "@/components/basic/StToggle.vue";

@Component({
  components: {
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker
  }
})
export default class PublicHolidayEdit extends Vue {
  editModel: PublicHolidayEditModel = PublicHolidayEditModel.fromJS({});
  groupId: number = 0;
  id: number = 0;
  date: string = "";

  loading: boolean = true;
  saving: boolean = false;
  deleting: boolean = false;
  listPage: string = "PublicHolidayGroupEdit";
  isNew: boolean = false;

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage, params: { id: this.groupId.toString() } });
  }

  created() {
    this.groupId = parseInt(this.$route.params.groupId);
    this.id = parseInt(this.$route.params.id);
    this.date = this.$route.params.date;
  }

  async mounted() {
    this.openSlideIn();
    this.editModel = this.id == 0 ? await stPublicHolidayApi.getNew(this.date, this.groupId) : await stPublicHolidayApi.get(this.id);
    this.loading = false;
  }

  async deleteItem() {
    try {
      this.deleting = true;
      if (this.editModel.isGlobalOverwrite) {
        await stPublicHolidayApi.overwriteAsWorkday(this.editModel);
      }else{
        await stPublicHolidayApi.delete(this.editModel.id!);
      }

      this.closeSlideIn();
    } finally {
      this.deleting = false;
    }
  }

  async submit() {
    try {
      this.saving = true;
      if (!this.editModel.id) {
        await stPublicHolidayApi.post(this.editModel);
      } else {
        await stPublicHolidayApi.put(this.editModel);
      }

      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
